module.exports = __webpack_public_path__ + "images/500.gif";